import React, { forwardRef } from "react";
import { cn } from "./cn";
import { INPUT_BASE, INPUT_ERROR } from "./Field";

/**
 * Bun one-time-code input (2FA). Spec: Component Library "Auth &
 * verification" — centered digits, 19/600, half-em tracking.
 *
 *   <Field label="Verification code"><CodeInput value={code} onChange={...} /></Field>
 */
const CodeInput = forwardRef(function CodeInput({ error, maxLength = 6, className, ...props }, ref) {
  return (
    <input
      ref={ref}
      inputMode="numeric"
      autoComplete="one-time-code"
      maxLength={maxLength}
      className={cn(
        INPUT_BASE,
        "text-center text-[19px] font-semibold tracking-[0.5em]",
        error && INPUT_ERROR,
        className
      )}
      {...props}
    />
  );
});

export default CodeInput;
